<template>
  <div class="max-w-5xl mx-auto mt-5">
    <ui-save-bar id="my-save-bar">
      <button
        variant="primary"
        id="save-button"
        @click="onSaveBarSaveClicked"
      ></button>
      <button id="discard-button" @click="onSaveBarDiscardClicked"></button>
    </ui-save-bar>
    <div class="">
      <WidgetInstaller
        v-if="shouldShowWidgetInstaller(config)"
      ></WidgetInstaller>
      <div class="bg-white shadow sm:rounded-lg">
        <div class="px-4 py-5 sm:p-6">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="renew-headline"
          >
            Whatsapp Chat
          </h3>
          <div class="mt-2 sm:flex sm:items-start sm:justify-between">
            <div class="max-w-xl text-sm leading-5 text-gray-500">
              <p id="renew-description">
                Enable or Disable WhatsApp chat on your store
              </p>
            </div>
            <div
              class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
            >
              <VSwitch :value="config.isEnabled" @input="handleSwitch" />
            </div>
          </div>
        </div>
      </div>
      <ChatConfigureForm
        :config="config"
        v-if="config.isEnabled"
        @save="updateConfig"
      />
      <div v-if="config.isEnabled">
        <DesktopSettings
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />
        <MobileSettings
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />
        <OfficeHours
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />
        <CalloutCard
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />
        <DefaultMessage
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />
        <ChatHideConfig
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />

        <ChatWidget
          v-if="config.isEnabled"
          :config="config"
          @save="updateConfig"
        />
      </div>

      <Notification :text="notificationText" :show="showNotification" />
    </div>
  </div>
</template>

<script>
import VSwitch from "../components/Common/VSwitch";

import ChatConfigureForm from "../components/Common/ChatConfigureForm";
import Notification from "../components/Common/Notification";

import OfficeHours from "../components/Chat/OfficeHours";
import ChatWidget from "../components/Chat/ChatWidget";
import CalloutCard from "../components/Chat/CalloutCard";
import DefaultMessage from "../components/Chat/DefaultMessage";
import ChatHideConfig from "../components/Chat/ChatHideConfig";
import MobileSettings from "../components/Chat/MobileSettings";
import DesktopSettings from "../components/Chat/DesktopSettings";

import WidgetInstaller from "../components/Chat/WidgetInstaller";

import { cloneDeep, isEqual } from "lodash-es";

export default {
  name: "Chat",
  components: {
    VSwitch,
    ChatConfigureForm,
    Notification,
    OfficeHours,
    ChatWidget,
    CalloutCard,
    DefaultMessage,
    ChatHideConfig,
    MobileSettings,
    DesktopSettings,
    WidgetInstaller
  },

  data() {
    return {
      config: {},
      originalConfig: {},
      notificationText: "",
      showNotification: false,
      saveBar: null
    };
  },
  computed: {
    hasAccessToChatWidget() {
      const store = this.$store.getters.getStore;
      return store.hasAccessToChatWidget;
    }
  },
  watch: {
    config: {
      deep: true,
      handler() {
        this.checkForChanges();
      }
    }
  },
  created() {
    this.init();
    this.updateOnboadingFlag();
  },
  mounted() {
    this.saveBar = document.getElementById("my-save-bar");
  },
  methods: {
    async init() {
      const response = await this.$store.dispatch("getChatConfig");
      this.config = response.config;
      this.originalConfig = cloneDeep(response.config);
    },
    checkForChanges() {
      if (!isEqual(this.config, this.originalConfig)) {
        this.saveBar.show();
      } else {
        this.saveBar.hide();
      }
    },
    onSaveBarSaveClicked() {
      this.updateConfig();
      this.saveBar.hide();
    },
    onSaveBarDiscardClicked() {
      this.config = cloneDeep(this.originalConfig);
      this.saveBar.hide();
    },
    updateConfig() {
      console.log(this.config);
      const chatConfig = { ...this.config };
      delete chatConfig.scriptTagId;
      delete chatConfig.isEnabled;
      this.$store
        .dispatch("updateChatConfig", { requestParams: chatConfig })
        .then(() => {
          this.displayNotification("settings updated");
          this.originalConfig = cloneDeep(this.config);
        });
    },
    activateChat() {
      this.$store.dispatch("activateChat").then(response => {
        if (response.authUrl) {
          if (window.top) {
            window.top.location = response.authUrl;
          } else {
            window.location.href = response.authUrl;
          }
        } else {
          this.config = response.config;
          this.originalConfig = cloneDeep(this.config);
          this.displayNotification("chat enabled");
        }
      });
    },
    deactivateChat() {
      this.$store.dispatch("deactivateChat").then(response => {
        this.config = response.config;
        this.originalConfig = cloneDeep(this.config);
        this.displayNotification("chat disabled");
      });
    },
    handleSwitch(value) {
      if (value) {
        this.activateChat();
        return;
      }
      this.deactivateChat();
    },
    shouldShowWidgetInstaller(config) {
      if (config && config.createdAt > 1747381243) {
        return true;
      }
      return false;
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    },
    updateOnboadingFlag() {
      this.$store.dispatch("updateOnboardingFlag", {
        requestParams: {
          flag: "isChatPageVisited"
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
